















import { Component, Vue } from "vue-property-decorator";

import AppText from "@/components/AppText.vue";
import ErrorAlert from "@/components/ErrorAlert.vue";
import LanguageModule from "@/store/modules/languageModule";
import Navigation from "@/components/Navigation.vue";
import { getModule } from "vuex-module-decorators";

const languageStore = getModule(LanguageModule);

@Component({
  components: { AppText, ErrorAlert, Navigation }
})
export default class App extends Vue {
  private time = 10 * 60 * 1000;
  private timer = setTimeout(this.onTimeout, this.time);

  private get background() {
    return this.$route.path == "/" ? "home" : "page";
  }

  private get style() {
    return {
      "--cursor": process.env.VUE_APP_CURSOR,
      "--font-family": process.env.VUE_APP_FONT_FAMILY,
      backgroundImage:
        "url(" + require(`@/assets/background/${this.background}.png`) + ")"
    };
  }

  private onClick() {
    this.restartTimer();
  }

  private onTimeout() {
    this.restartTimer();
    this.navigateHome();
  }

  private restartTimer() {
    clearTimeout(this.timer);
    this.timer = setTimeout(this.onTimeout, this.time);
  }

  private navigateHome() {
    const route = "/";

    if (route != this.$router.currentRoute.path) {
      this.$router.push(route);
      languageStore.set("fr_CH");
    }
  }
}
